var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "cargo-advance-search",
            staticStyle: {
              width: "100%",
              "margin-top": "5px",
              "min-width": "1280px"
            }
          },
          [
            _c(
              "el-form",
              { attrs: { "label-position": "middle", "label-width": "80px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-form-item-wrapper",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_InstructionChineseName")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            placeholder: _vm.$t("SeaExport.PleaseInputAKeyword")
                          },
                          model: {
                            value: _vm.filter.chineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "chineseName", $$v)
                            },
                            expression: "filter.chineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "padding-left": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "3", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.filter.pageNum = 1
                                _vm.queryHandler()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { no: "4", type: "primary" },
                            on: { click: _vm.addHandler }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { no: "5", type: "primary" },
                            on: { click: _vm.editHandler }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Edit")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { no: "6", type: "danger" },
                            on: { click: _vm.deleteHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_OrderDelete")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _vm.dataType === _vm.INSTRUCTION_TREE_DATE_TYPE_LOB.code
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "flex-grow": "1"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "app-main-inner-row",
                    staticStyle: { "flex-grow": "1", "min-height": "400px" }
                  },
                  [
                    _c("cargo-ag-grid", {
                      attrs: {
                        no: "grid",
                        "config-module": "1014252",
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.rowData,
                        "grid-params": _vm.girdParams,
                        "grid-options": _vm.gridOptions
                      },
                      on: {
                        "update:gridParams": function($event) {
                          _vm.girdParams = $event
                        },
                        "update:grid-params": function($event) {
                          _vm.girdParams = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "app-main-inner-row row-pagination" },
                  [
                    _c("cargo-pagination", {
                      attrs: {
                        no: "pagination",
                        "config-module": "1014252",
                        total: _vm.total,
                        page: _vm.filter.pageNum,
                        limit: _vm.filter.pageSize
                      },
                      on: {
                        "update:page": function($event) {
                          return _vm.$set(_vm.filter, "pageNum", $event)
                        },
                        "update:limit": function($event) {
                          return _vm.$set(_vm.filter, "pageSize", $event)
                        },
                        pagination: _vm.queryHandler
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]),
      _vm.settingDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              ref: "settingDialog",
              attrs: {
                visible: _vm.settingDialog.visible,
                title: _vm.settingDialog.title,
                width: "700px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.settingDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "130px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_InstructionType"),
                            "label-width": "130px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "390px" },
                            attrs: {
                              clearable: false,
                              no: "instructionType",
                              "tag-value": "code",
                              filterable: "",
                              "default-value":
                                _vm.settingDialog.form.instructionType,
                              "static-options": _vm.INSTRUCTION_TYPES
                            },
                            on: { parentCallBack: _vm.instructionTypeChange }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_InstructionCode")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "390px" },
                            attrs: { no: "instructionCode" },
                            on: {
                              blur: function() {
                                return (_vm.settingDialog.form.instructionCode = _vm.settingDialog.form.instructionCode.trim())
                              }
                            },
                            model: {
                              value: _vm.settingDialog.form.instructionCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settingDialog.form,
                                  "instructionCode",
                                  $$v
                                )
                              },
                              expression: "settingDialog.form.instructionCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CommandDisplayName")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { no: "instructionDisplayName" },
                              model: {
                                value: _vm.settingDialog.instructionDisplayName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settingDialog,
                                    "instructionDisplayName",
                                    $$v
                                  )
                                },
                                expression:
                                  "settingDialog.instructionDisplayName"
                              }
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: _vm.ZH_CN.code } },
                                [_vm._v(_vm._s(_vm.$t("Tool.Chinese")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: _vm.EN_US.code } },
                                [_vm._v(_vm._s(_vm.$t("Tool.English")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: _vm.JA_JP.code } },
                                [_vm._v(_vm._s(_vm.$t("Tool.Japanese")))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { width: "390px" } },
                            [
                              _vm.settingDialog.instructionDisplayName ===
                              _vm.ZH_CN.code
                                ? _c("el-input", {
                                    attrs: { no: "chineseName" },
                                    on: {
                                      blur: function() {
                                        return (_vm.settingDialog.form.chineseName = _vm.settingDialog.form.chineseName.trim())
                                      }
                                    },
                                    model: {
                                      value: _vm.settingDialog.form.chineseName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settingDialog.form,
                                          "chineseName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settingDialog.form.chineseName"
                                    }
                                  })
                                : _vm._e(),
                              _vm.settingDialog.instructionDisplayName ===
                              _vm.EN_US.code
                                ? _c("el-input", {
                                    attrs: { no: "englishName" },
                                    on: {
                                      blur: function() {
                                        return (_vm.settingDialog.form.englishName = _vm.settingDialog.form.englishName.trim())
                                      }
                                    },
                                    model: {
                                      value: _vm.settingDialog.form.englishName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settingDialog.form,
                                          "englishName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settingDialog.form.englishName"
                                    }
                                  })
                                : _vm._e(),
                              _vm.settingDialog.instructionDisplayName ===
                              _vm.JA_JP.code
                                ? _c("el-input", {
                                    attrs: { no: "japaneseName" },
                                    on: {
                                      blur: function() {
                                        return (_vm.settingDialog.form.japaneseName = _vm.settingDialog.form.japaneseName.trim())
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.settingDialog.form.japaneseName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settingDialog.form,
                                          "japaneseName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settingDialog.form.japaneseName"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_InstructionDescription"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "390px" },
                            attrs: {
                              no: "instructionDescription",
                              type: "textarea",
                              rows: 3
                            },
                            on: {
                              blur: function() {
                                return (_vm.settingDialog.form.instructionDescription = _vm.settingDialog.form.instructionDescription.trim())
                              }
                            },
                            model: {
                              value:
                                _vm.settingDialog.form.instructionDescription,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settingDialog.form,
                                  "instructionDescription",
                                  $$v
                                )
                              },
                              expression:
                                "settingDialog.form.instructionDescription"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_SelectOperationInstruction"
                            )
                          }
                        },
                        [
                          _c("platform-instruction-dialog", {
                            attrs: {
                              width: "600px",
                              lob: _vm.lob,
                              "platform-instruction-uuid":
                                _vm.settingDialog.form.platformInstructionUuid,
                              "platform-instructions": _vm.platformInstructions,
                              "instruction-type":
                                _vm.settingDialog.form.instructionType
                            },
                            on: { change: _vm.platformInstructionChange }
                          })
                        ],
                        1
                      ),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_SEND_EMAIL.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IfAllowedSendMultipleTimes"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "allowMultipleOperations" },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .allowMultipleOperations,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form,
                                            "allowMultipleOperations",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.allowMultipleOperations"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanOnlyBeSentOnce"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanBeSentMultipleTimes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_TemplateMatching"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "390px" },
                                      attrs: {
                                        no: "matchOfficeTemplate",
                                        maxlength: "20"
                                      },
                                      on: { change: _vm.selectPushLinkChange },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson.selectPushLink,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "selectPushLink",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.selectPushLink"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_UnifiedBusinessScenario"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.getMailboxManagementDialogTitle()
                                  }
                                },
                                [
                                  _c("mailbox-management-dialog", {
                                    attrs: {
                                      width: "600px",
                                      lob: _vm.lob,
                                      "mail-template-uuid":
                                        _vm.settingDialog.form
                                          .instructionRuleJson.mailTemplateUuid,
                                      "push-link":
                                        _vm.settingDialog.form
                                          .instructionRuleJson.pushLink,
                                      "mail-templates": _vm.mailTemplates,
                                      "select-push-link":
                                        _vm.settingDialog.form
                                          .instructionRuleJson.selectPushLink
                                    },
                                    on: { change: _vm.emailTemplateChange }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_UPLOAD_FILE.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_SetUploadFileType"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "390px" },
                                      attrs: { no: "fileCategoryLabel" },
                                      nativeOn: {
                                        click: function($event) {
                                          _vm.fileTypeEditor.visible = true
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .fileCategoryLabel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "fileCategoryLabel",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.fileCategoryLabel"
                                      }
                                    },
                                    _vm._l(
                                      [
                                        _vm.settingDialog.form
                                          .instructionRuleJson.fileCategoryLabel
                                      ],
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: { label: item, value: item }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_PRINT_FILE.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IfAllowedSendMultipleTimes"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "allowMultipleOperations2" },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .allowMultipleOperations,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form,
                                            "allowMultipleOperations",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.allowMultipleOperations"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanOnlyPrintOnce"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanPrintMultipleTimes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_TemplateMatching"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "390px" },
                                      attrs: {
                                        no: "selectFileType",
                                        maxlength: "20"
                                      },
                                      on: { change: _vm.selectFileTypeChange },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson.selectFileType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "selectFileType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.selectFileType"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_IfSelectTemplateType"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_PrintMode")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "200px"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: { width: "390px" },
                                          attrs: {
                                            no: "singleJobPrint",
                                            maxlength: "20"
                                          },
                                          on: {
                                            change: _vm.singleJobPrintChange
                                          },
                                          model: {
                                            value:
                                              _vm.settingDialog.form
                                                .instructionRuleJson
                                                .singleJobPrint,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settingDialog.form
                                                  .instructionRuleJson,
                                                "singleJobPrint",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settingDialog.form.instructionRuleJson.singleJobPrint"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_SingleJobPrint"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: { width: "390px" },
                                          attrs: {
                                            no: "batchJobPrint",
                                            maxlength: "20"
                                          },
                                          on: {
                                            change: _vm.batchJobPrintChange
                                          },
                                          model: {
                                            value:
                                              _vm.settingDialog.form
                                                .instructionRuleJson
                                                .batchJobPrint,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settingDialog.form
                                                  .instructionRuleJson,
                                                "batchJobPrint",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settingDialog.form.instructionRuleJson.batchJobPrint"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_BatchJobPrint"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm.settingDialog.form.instructionRuleJson
                                .singleJobPrint
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.getTemplateManagementDialogTitle()
                                      }
                                    },
                                    [
                                      _c("template-management-dialog", {
                                        attrs: {
                                          width: "600px",
                                          lob: _vm.lob,
                                          "template-uuids":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .templateUuids,
                                          "document-type-uuid":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .documentTypeUuid,
                                          templates: _vm.templates,
                                          "select-file-type":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .selectFileType
                                        },
                                        on: { change: _vm.templateChange }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.settingDialog.form.instructionRuleJson
                                .batchJobPrint
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.getBatchTemplateManagementDialogTitle()
                                      }
                                    },
                                    [
                                      _c("batch-template-management-dialog", {
                                        attrs: {
                                          width: "600px",
                                          lob: _vm.lob,
                                          "batch-template-uuid":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .batchTemplateUuid,
                                          "bach-document-type-uuid":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .bachDocumentTypeUuid,
                                          templates: _vm.templates,
                                          "select-file-type":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .selectFileType
                                        },
                                        on: { change: _vm.batchTemplateChange }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_JUMP_PAGE.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_SelectJumpPage"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "390px" },
                                      attrs: { no: "jumpPath" },
                                      nativeOn: {
                                        click: function($event) {
                                          _vm.treeEditor.visible = true
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson.jumpName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "jumpName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.jumpName"
                                      }
                                    },
                                    _vm._l(
                                      [
                                        _vm.settingDialog.form
                                          .instructionRuleJson.jumpName
                                      ],
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: { label: item, value: item }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_JumpSet")
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { width: "390px" },
                                      attrs: {
                                        no: "selectFileType",
                                        maxlength: "20"
                                      },
                                      on: { change: _vm.selectFileTypeChange },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .clickJobNoJumpPage,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "clickJobNoJumpPage",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.clickJobNoJumpPage"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ClickJobNoJumpPage"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_DATA_FILL.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IfAllowedSendMultipleTimes"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "allowMultipleOperations" },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .allowMultipleOperations,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form,
                                            "allowMultipleOperations",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.allowMultipleOperations"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanOnlyBeSentOnce"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanBeSentMultipleTimes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.FillInMode"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change:
                                          _vm.singleTicketBusinessEntryChange
                                      },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .singleTicketBusinessEntry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "singleTicketBusinessEntry",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.singleTicketBusinessEntry"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.SingleTicketBusinessForm"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change:
                                          _vm.batchBusinessProcessingChange
                                      },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .batchBusinessProcessing,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "batchBusinessProcessing",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.batchBusinessProcessing"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BulkProcessing"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.SingleFormSubmission"
                                    )
                                  }
                                },
                                [
                                  _c("custom-form-select-dialog", {
                                    attrs: {
                                      width: "600px",
                                      lob: _vm.lob,
                                      "form-uuid":
                                        _vm.settingDialog.form
                                          .instructionRuleJson.singleFormUuid,
                                      "form-name":
                                        _vm.settingDialog.form
                                          .instructionRuleJson.singleFormName,
                                      "form-list": _vm.uiCustomForms,
                                      "application-scene":
                                        _vm.APPLICATION_SCENE.BUSINESS_SINGLE
                                          .value,
                                      disabled: !_vm.settingDialog.form
                                        .instructionRuleJson
                                        .singleTicketBusinessEntry
                                    },
                                    on: {
                                      change: function(data) {
                                        if (
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .singleTicketBusinessEntry
                                        ) {
                                          ;(_vm.settingDialog.form.instructionRuleJson.singleFormUuid =
                                            data.uuid),
                                            (_vm.settingDialog.form.instructionRuleJson.singleFormName =
                                              data.name)
                                        }
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.BatchFillOutForms"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c("custom-form-select-dialog", {
                                        attrs: {
                                          width: "600px",
                                          lob: _vm.lob,
                                          "form-uuid":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .batchFormUuid,
                                          "form-name":
                                            _vm.settingDialog.form
                                              .instructionRuleJson
                                              .batchFormName,
                                          "form-list": _vm.uiCustomForms,
                                          "application-scene":
                                            _vm.APPLICATION_SCENE.BUSINESS_BATCH
                                              .value,
                                          disabled: !_vm.settingDialog.form
                                            .instructionRuleJson
                                            .batchBusinessProcessing
                                        },
                                        on: {
                                          change: function(data) {
                                            if (
                                              _vm.settingDialog.form
                                                .instructionRuleJson
                                                .batchBusinessProcessing
                                            ) {
                                              ;(_vm.settingDialog.form.instructionRuleJson.batchFormUuid =
                                                data.uuid),
                                                (_vm.settingDialog.form.instructionRuleJson.batchFormName =
                                                  data.name)
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            disabled: !_vm.settingDialog.form
                                              .instructionRuleJson
                                              .batchBusinessProcessing
                                          },
                                          model: {
                                            value:
                                              _vm.settingDialog.form
                                                .instructionRuleJson
                                                .batchModificationPrompt,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settingDialog.form
                                                  .instructionRuleJson,
                                                "batchModificationPrompt",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settingDialog.form.instructionRuleJson.batchModificationPrompt"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "SystemMaintenance.BatchModificationPrompt"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.settingDialog.form.instructionType ===
                      _vm.INSTRUCTION_TYPE_OTHER_OPERATION.code
                        ? _c(
                            "div",
                            [
                              _c("el-divider"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_InstructionRuleSetting"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_IfAllowedSendMultipleTimes"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "allowMultipleOperations" },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .allowMultipleOperations,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form,
                                            "allowMultipleOperations",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.allowMultipleOperations"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanOnlyBeSentOnce"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_CanBeSentMultipleTimes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SystemMaintenance.BatchOperationSettings"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: { change: _vm.batchOperateChange },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson.batchOperate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "batchOperate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.batchOperate"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BatchOperationsSupported"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !_vm.settingDialog.form
                                          .instructionRuleJson.batchOperate
                                      },
                                      model: {
                                        value:
                                          _vm.settingDialog.form
                                            .instructionRuleJson
                                            .batchOperateTip,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingDialog.form
                                              .instructionRuleJson,
                                            "batchOperateTip",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settingDialog.form.instructionRuleJson.batchOperateTip"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BulkOperationPrompt"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "13", type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "14" },
                      on: {
                        click: function($event) {
                          _vm.settingDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.lob,
              "file-id": "",
              "file-category":
                _vm.settingDialog.form.instructionRuleJson.fileCategory || "",
              "row-selection": _vm.ROW_SELECTION_SINGLE.code
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.saveFileTypeHandle
            }
          })
        : _vm._e(),
      _vm.treeEditor.visible
        ? _c("tree-editor", {
            attrs: {
              visible: _vm.treeEditor.visible,
              path: _vm.settingDialog.form.instructionRuleJson.jumpPath || "",
              "append-to-body": true,
              "row-selection": _vm.ROW_SELECTION_SINGLE.code,
              title: _vm.$t("CargoMsg.Cargo_SelectJumpPage"),
              "row-data": _vm.jumpTree
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.treeEditor, "visible", $event)
              },
              callback: _vm.saveJumpPath
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }